import { Card, CardContent, Typography, Box, Chip, Grid } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import React from 'react';
import { t } from 'i18next';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import NotesIcon from '@mui/icons-material/Notes';

const NutriPlanViewer = ({ days, foodsToAvoid, customNotes }) => {
    return (
        <Box>
            {days.map((day) => (
                <Card
                    key={day.dayNumber}
                    variant="outlined"
                    sx={{
                        borderRadius: 3,
                        boxShadow: 1,
                        backgroundColor: '#fff',
                        mt: 2,
                        ml: 2,
                        overflow: 'hidden'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.2,
                            bgcolor: '#1976d2',
                            color: 'white',
                            px: 2,
                            py: 1.2
                        }}
                    >
                        <CalendarTodayIcon fontSize="small" />
                        <Typography variant="h5" fontWeight="600" color="white">
                            {t('nutrition.day')} {day.dayNumber}
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="600" color="white">
                            {day.objective}
                        </Typography>
                    </Box>

                    <CardContent>
                        <Typography variant="subtitle1" gutterBottom>
                            <RestaurantIcon
                                fontSize="small"
                                sx={{ mr: 0.5, verticalAlign: 'middle' }}
                            />
                            {t('nutrition.meals')}
                        </Typography>
                        <Grid container spacing={2}>
                            {day.meals.map((meal) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    key={meal.mealType}
                                    sx={{ display: 'flex' }}
                                >
                                    <Box
                                        sx={{
                                            border: '1px solid #eee',
                                            borderRadius: 2,
                                            p: 2,
                                            backgroundColor: '#fafafa',
                                            transition: '0.2s',
                                            '&:hover': { backgroundColor: '#f5f5f5' },
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        <Typography variant="subtitle1" fontWeight="bold">
                                            {meal.title || meal.mealType}
                                        </Typography>

                                        {meal.options.map((opt) => (
                                            <Box key={opt.optionId} sx={{ mb: 1 }}>
                                                <Typography variant="body2">
                                                    {opt.label ||
                                                        `Option ${opt.optionId}`}
                                                </Typography>

                                                <ul>
                                                    {opt.items.map((i, idx) => (
                                                        <li key={idx}>
                                                            {i.quantity} - {i.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Box>
                                        ))}
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>
            ))}

            <Grid container spacing={2} sx={{ mt: 4 }}>
                <Grid item xs={12} md={6}>
                    <Card
                        variant="outlined"
                        sx={{
                            borderRadius: 3,
                            boxShadow: 1,
                            backgroundColor: '#fff',
                            mt: 2,
                            ml: 2,
                            overflow: 'hidden',
                            height: '100%'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.2,
                                bgcolor: '#1976d2',
                                color: 'white',
                                px: 2,
                                py: 1.2
                            }}
                        >
                            <PriorityHighIcon fontSize="small" />
                            <Typography variant="h5" fontWeight="600" color="white">
                                {t('nutrition.avoid')}
                            </Typography>
                        </Box>
                        <CardContent>
                            {foodsToAvoid.map((cat, index) => (
                                <Box key={index} sx={{ mb: 2 }}>
                                    <Typography variant="subtitle1">
                                        {cat.category}
                                    </Typography>

                                    {cat.items.map((item, idx) => (
                                        <Chip
                                            key={idx}
                                            label={item}
                                            color="#1976d2"
                                            variant="outlined"
                                            sx={{ mr: 1, mt: 1 }}
                                        />
                                    ))}
                                </Box>
                            ))}
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Card
                        variant="outlined"
                        sx={{
                            borderRadius: 3,
                            boxShadow: 1,
                            backgroundColor: '#fff',
                            mt: 2,
                            ml: 2,
                            overflow: 'hidden',
                            height: '100%'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.2,
                                bgcolor: '#1976d2',
                                color: 'white',
                                px: 2,
                                py: 1.2
                            }}
                        >
                            <NotesIcon fontSize="small" />
                            <Typography variant="h5" fontWeight="600" color="white">
                                {t('nutrition.notes')}
                            </Typography>
                        </Box>
                        <CardContent>
                            <ul>
                                {customNotes.map((n, i) => (
                                    <li key={i}>
                                        <Typography>{n}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default NutriPlanViewer;
